import { ContentCard, Row, TruncatedAccount } from "@narmi/design_system";
import Account from "byzantine/src/Account";
import Filters from "byzantine/src/filters";
import styles from "./OrganizationRoles.module.scss";

function AccountTile({ account }: { account: API.Account | API.ExternalAccount }) {
  const deserializedAccount = Account.deserialize(account);
  const { name, endingValue } =
    deserializedAccount.getTruncatedValuesWithoutBalance();
  const formattedAccountType = Filters.humanize(account.product.type);

  return (
    <div className={styles.accountTile}>
      <ContentCard kind="bordered">
        <Row gapSize="s">
          <Row.Item shrink>
            <div
              className={`nds-icon-button nds-icon-button--themed ${styles.IconWrapper}`}
            >
              <span
                className={`narmi-icon-bank ${styles.accountsIcon}`}
                aria-hidden="true"
              />
            </div>
          </Row.Item>
          <Row.Item className={styles.accountsTextContainer}>
            <div className={styles.accountsTitle}>
              <TruncatedAccount name={name} lastFour={endingValue} />
            </div>
            {formattedAccountType && (
              <p className={styles.accountsType}>{formattedAccountType}</p>
            )}
          </Row.Item>
        </Row>
      </ContentCard>
    </div>
  );
}

export default AccountTile;
